/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ContinueInputs */



/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Common_ContinueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_continue = /** @type {((inputs?: Common_ContinueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ContinueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitermachen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continuare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继续")
	if (locale === "ja") return /** @type {LocalizedString} */ ("続く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जारी रखना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Continuar")
	return /** @type {LocalizedString} */ ("Continue")
});